import React from "react";
import styles from "./sortChipRow.module.css";
import { ReactComponent as UpDownFilterIcon } from "../../../assets/icons/general/upDownFilterIcon.svg";

const options = [
  { value: "cart_id", label: "Cart ID" },
  { value: "severity", label: "Severity" },
  { value: "open_date_time", label: "Date" },
];

export default function SortChipRow({ sortOption, sortDirection, onChange }) {
  const handleClick = (optionValue) => {
    if (sortOption === optionValue) {
      // Toggle sort direction if the same option is clicked again
      const newDirection = sortDirection === "asc" ? "desc" : "asc";
      onChange(optionValue, newDirection);
    } else {
      // Set new option with default ascending order
      onChange(optionValue, "asc");
    }
  };

  return (
    <div className={styles.sortChipRow}>
      {options.map((option) => (
        <div
          key={option.value}
          className={`${styles.option} ${
            sortOption === option.value ? styles.active : ""
          }`}
          onClick={() => handleClick(option.value)}
        >
          <span className={styles.label}>{option.label}</span>
          {sortOption === option.value && (
            <UpDownFilterIcon className={styles.icon} />
          )}
        </div>
      ))}
    </div>
  );
}
